export default class buttonRenderer {
  // gets called once before the renderer is used
  init(params) {
    // create the cell
    this.eGui = document.createElement("div");
    
    // Vérifier si une action a déjà été effectuée
    // Si oui, ne pas afficher les boutons
    if (params.data.action === "reporter" || params.data.action === "solder") {
      this.eGui.innerHTML = "";
      return;
    }

    // Sinon, créer les boutons normalement
    this.eGui.innerHTML = `
            <button class="btn-simple reporter">Reporter</button>
            <button class="btn-simple solder">Solder</button>
         `;

    // get references to the elements we want
    this.reporterButton = this.eGui.querySelector(".btn-simple.reporter");
    this.solderButton = this.eGui.querySelector(".btn-simple.solder");

    // add event listener to buttons
    this.reporterButtoneventListener = () => {
      const quantite = params.data.quantite;
      const stockActuel = params.data.stockActuel;
      params.node.setDataValue("stockActuel", Number(stockActuel - quantite));
      // params.node.setDataValue("stockFutur", Number(quantite));
      params.node.setDataValue("quantite", Number(quantite));
      params.node.setDataValue("action", "reporter");
      this.eGui.innerHTML = "";
    };
    this.solderButtoneventListener = () => {
      const quantite = params.data.quantite;
      const stockActuel = params.data.stockActuel;
      params.node.setDataValue("stockActuel", Number(stockActuel - quantite));
      // params.node.setDataValue("quantite", Number(quantite));
      params.node.setDataValue("quantite", 0);
      params.node.setDataValue("action", "solder");
      this.eGui.innerHTML = "";
    };
    this.reporterButton.addEventListener(
      "click",
      this.reporterButtoneventListener
    );
    this.solderButton.addEventListener("click", this.solderButtoneventListener);
  }

  getGui() {
    return this.eGui;
  }

  // gets called whenever the cell refreshes
  refresh(params) {
    // Si une action a déjà été effectuée (reporter ou solder),
    // on garde la cellule vide
    if (params.data.action === "reporter" || params.data.action === "solder") {
      this.eGui.innerHTML = "";
      return true;
    }
    // Sinon, on peut retourner false pour forcer ag-grid à recréer le renderer
    // avec les boutons initiaux
    return false;
  }
}
